import FirebaseProvider from './firebase/Provider'
import MenuProvider from './menu/MenuProvider'
import CallProvider from './call/CallProvider'
import React from 'react'

const AppProvider = ({ children }) => {
  return (
    <FirebaseProvider>
      <CallProvider>
        <MenuProvider>
          {children}
        </MenuProvider>
      </CallProvider>
    </FirebaseProvider>
  )
}

export default AppProvider